export type Locale = 'ru' | 'en';

const ru = {
  'nav.home': 'На главную TonSuite',
  'nav.back': 'Назад',
  'nav.source': 'Open source',
  'nav.language': 'English version',
  'nav.languageShort': 'EN',
  'status.local': '100% локально',
  'sticker.setup': 'Утя выбирает красивое окончание',
  'sticker.searching': 'Утя охотится за адресом',
  'sticker.found': 'Утя празднует найденный адрес',
  'sticker.seed': 'Утя хранит секрет',
  'setup.title': 'Поймай красивый TON-адрес',
  'setup.description': 'Утя перебирает кошельки прямо на вашем устройстве. Адреса и сид-фразы никуда не отправляются.',
  'settings.title': 'Настройки генератора',
  'suffix.label': 'Окончание адреса',
  'suffix.required': 'Введите хотя бы один символ',
  'suffix.characters': 'Допустимы A–Z, a–z, 0–9, _ и -',
  'suffix.maximum': 'До 8 символов — дальше ожидание практически бесконечно',
  'estimate.enter': 'Введите окончание',
  'estimate.attempts': '≈ {count} попыток',
  'estimate.realistic': '≈ {count} попыток — реально',
  'estimate.long': '≈ {count} попыток — надолго',
  'estimate.veryLong': '≈ {count} попыток — очень надолго',
  'presets.label': 'Примеры окончаний',
  'wallet.title': 'Версия кошелька',
  'wallet.description': 'Совместима с TON-кошельками',
  'wallet.group': 'Версия кошелька',
  'wallet.recommended': 'Рекомендуется',
  'wallet.compatibility': 'Совместимость',
  'advanced.title': 'Дополнительно',
  'mnemonic.title': 'Сид-фраза',
  'mnemonic.description': 'Выберите стандарт восстановления',
  'mnemonic.12': '12 слов',
  'mnemonic.24': '24 слова',
  'mnemonic.fast': 'Быстрее',
  'device.measure': 'Автоподбор скорости',
  'device.measureHint': 'Локальный тест · около {seconds} сек',
  'device.measuring': 'Тест {current}/{total} · {engine} · {count}',
  'device.cancelMeasure': 'Остановить локальный тест',
  'device.measured': 'Скорость подобрана',
  'device.measuredValue': '{engine} · {count} · ≈ {speed}/с',
  'device.measureFailed': 'Не удалось измерить скорость',
  'device.measureFailedHint': 'Выберите CPU · Авто или попробуйте тест ещё раз.',
  'case.title': 'Учитывать регистр',
  'case.exact': 'Точное совпадение: сложнее',
  'case.relaxed': 'MONEY совпадёт с money',
  'threads.title': 'Потоки CPU',
  'threads.description': 'Больше потоков — выше нагрузка и нагрев',
  'threads.gpuTitle': 'GPU-конвейеры',
  'threads.gpuDescription': '{count} параллельных WebGPU-конвейеров',
  'threads.auto': 'Авто · {count}',
  'threads.maximum': 'Максимум · {count}',
  'threads.manual': '{count}',
  'compute.title': 'Ускорение',
  'compute.description': 'Выберите вычислительный движок',
  'compute.cpu': 'CPU',
  'compute.cpuDescription': 'Стабильный режим · несколько потоков',
  'compute.gpu': 'GPU · Beta',
  'compute.gpuDescription': 'Параллельные WebGPU-конвейеры · максимум скорости',
  'compute.gpuUnavailable': 'WebGPU недоступен в этом браузере',
  'compute.gpuPreparing': 'Проверяем видеокарту…',
  'compute.mobileTitle': 'Режим для телефона',
  'compute.mobileDescription': 'GPU скрыт, по умолчанию {count} CPU-потока без лишнего нагрева',
  'format.title': 'Формат адреса',
  'format.nonBounceable': 'Non-bounceable · удобно для получения',
  'format.bounceable': 'Bounceable · стандартный формат',
  'consent.title': 'Я понимаю, как сохранить кошелёк',
  'consent.description': 'Если закрыть вкладку до сохранения сид-фразы, восстановить найденный кошелёк будет невозможно.',
  'action.start': 'Начать охоту',
  'privacy.localCompute': 'Всё считается на этом устройстве',
  'search.title': 'Утя уже охотится',
  'search.description': 'Ищем …{suffix} в {version}-адресах · {engine}. Можно оставить вкладку открытой.',
  'search.running': 'Перебор идёт',
  'search.attempts': 'попыток проверено',
  'search.speed': 'Скорость',
  'search.time': 'Время',
  'search.estimate': 'Ориентир',
  'search.sample': 'Последний кандидат',
  'search.preparing': 'Готовим генератор…',
  'search.random': 'Поиск случайный. Ожидание может оказаться короче или длиннее расчёта.',
  'search.stop': 'Остановить',
  'search.paused': 'Охота на паузе',
  'search.pause': 'Пауза',
  'search.resume': 'Продолжить',
  'search.power': 'Мощность',
  'power.title': 'Мощность поиска',
  'power.description': 'Измените движок или число потоков. Счётчик и активное время сохранятся.',
  'power.close': 'Закрыть настройки мощности',
  'power.current': 'Будет запущено: {count}',
  'power.apply': 'Применить мощность',
  'engine.cpu': 'CPU · {count}',
  'engine.gpu': 'GPU · WebGPU',
  'engine.gpuParallel': 'GPU · {count} конвейеров',
  'eta.measuring': 'Измеряем…',
  'eta.minutes': '≈ {count} мин',
  'eta.hours': '≈ {count} ч',
  'eta.days': '≈ {count} дн',
  'eta.years': '≈ {count} лет',
  'found.status': 'Найдено',
  'found.title': 'Вот это адрес!',
  'found.description': 'Утя нашёл нужное окончание. Проверьте адрес, прежде чем сохранить кошелёк.',
  'found.copyAddress': 'Скопировать адрес',
  'found.copiedAddress': 'Адрес скопирован',
  'found.attempts': 'Попыток',
  'found.time': 'Время',
  'found.hiddenTitle': 'Сид пока скрыт',
  'found.hiddenDescription': 'Он существует только в памяти этой вкладки и исчезнет после закрытия.',
  'found.reveal': 'Использовать этот адрес',
  'found.revealPending': 'Готовим сид-фразу…',
  'found.retry': 'Искать другой адрес',
  'seedReady.status': 'Сид ещё не раскрыт',
  'seedReady.title': 'Готовы сохранить ключ?',
  'seedReady.description': 'Сид-фраза из {count} слов появится только после вашего подтверждения. До этого она остаётся внутри генератора.',
  'seedReady.check': 'Я нахожусь в безопасном месте',
  'seedReady.checkDescription': 'Экран никто не видит, запись экрана и трансляция отключены.',
  'seedReady.reveal': 'Показать сид-фразу',
  'seedReady.back': 'Вернуться к адресу',
  'seed.status': 'Только для вас',
  'seed.title': 'Сохраните сид-фразу',
  'seed.description': 'Это единственный ключ к кошельку. Запишите слова по порядку и храните офлайн.',
  'seed.warningTitle': 'Никому не показывайте сид-фразу',
  'seed.warningDescription': 'TonSuite никогда не попросит эти слова в чате, боте или поддержке.',
  'seed.phrase': 'Секретная фраза',
  'seed.hide': 'Скрыть',
  'seed.show': 'Показать',
  'seed.hidden': 'Сид-фраза скрыта',
  'seed.copied': 'Скопировано',
  'seed.copy': 'Скопировать сид-фразу',
  'seed.restart': 'Я сохранил — начать заново',
  'seed.notStored': 'Фраза не сохраняется в браузере',
  'footer.privacy': 'Конфиденциальность',
  'footer.utya': 'Утя',
  'footer.author': 'Автор · @rub1kub',
  'footer.channel': 'Канал разработчика',
  'huntModal.close': 'Закрыть окно',
  'huntModal.status': 'Охота началась',
  'huntModal.title': 'Всё бесплатно и чики-пуки',
  'huntModal.description': 'Генератор уже ищет адрес на вашем устройстве. Подпишитесь на канал разработчика — там обновления TonSuite, новые инструменты и никакой скуки.',
  'huntModal.notification': 'Когда кошелёк найдётся, прозвучит сигнал и появится системное уведомление — если браузер разрешит.',
  'huntModal.subscribe': 'Подписаться на канал',
  'huntModal.continue': 'Продолжить охоту',
  'notification.title': 'TonSuite: кошелёк найден!',
  'notification.body': 'Утя поймал TON-адрес с нужным окончанием. Вернитесь во вкладку, чтобы проверить его.',
  'error.generator': 'Не удалось запустить локальный генератор. Обновите страницу или браузер.',
  'error.walletMissing': 'Найденный кошелёк уже недоступен. Запустите поиск заново.',
  'error.clipboard': 'Браузер не дал доступ к буферу обмена. Скопируйте вручную.',
  'error.gpuFallback': 'GPU не прошёл самопроверку. Поиск продолжен на CPU.',
} as const;

export type MessageKey = keyof typeof ru;

const en: Record<MessageKey, string> = {
  'nav.home': 'Back to TonSuite home',
  'nav.back': 'Back',
  'nav.source': 'Open source',
  'nav.language': 'Русская версия',
  'nav.languageShort': 'RU',
  'status.local': '100% local',
  'sticker.setup': 'Utya chooses a beautiful ending',
  'sticker.searching': 'Utya is hunting for an address',
  'sticker.found': 'Utya celebrates the address',
  'sticker.seed': 'Utya keeps the secret',
  'setup.title': 'Catch a beautiful TON address',
  'setup.description': 'Utya searches for wallets directly on your device. Addresses and recovery words are never sent anywhere.',
  'settings.title': 'Generator settings',
  'suffix.label': 'Address ending',
  'suffix.required': 'Enter at least one character',
  'suffix.characters': 'Use A–Z, a–z, 0–9, _ or -',
  'suffix.maximum': 'Up to 8 characters — longer searches are practically endless',
  'estimate.enter': 'Enter an ending',
  'estimate.attempts': '≈ {count} attempts',
  'estimate.realistic': '≈ {count} attempts — realistic',
  'estimate.long': '≈ {count} attempts — a long search',
  'estimate.veryLong': '≈ {count} attempts — extremely long',
  'presets.label': 'Ending examples',
  'wallet.title': 'Wallet version',
  'wallet.description': 'Compatible with TON wallets',
  'wallet.group': 'Wallet version',
  'wallet.recommended': 'Recommended',
  'wallet.compatibility': 'Compatibility',
  'advanced.title': 'Advanced',
  'mnemonic.title': 'Recovery phrase',
  'mnemonic.description': 'Choose the recovery standard',
  'mnemonic.12': '12 words',
  'mnemonic.24': '24 words',
  'mnemonic.fast': 'Faster',
  'device.measure': 'Auto-tune speed',
  'device.measureHint': 'Local test · about {seconds} sec',
  'device.measuring': 'Test {current}/{total} · {engine} · {count}',
  'device.cancelMeasure': 'Stop the local test',
  'device.measured': 'Speed tuned',
  'device.measuredValue': '{engine} · {count} · ≈ {speed}/s',
  'device.measureFailed': 'Speed test could not finish',
  'device.measureFailedHint': 'Use CPU · Auto or run the test again.',
  'case.title': 'Match letter case',
  'case.exact': 'Exact match: harder',
  'case.relaxed': 'MONEY also matches money',
  'threads.title': 'CPU workers',
  'threads.description': 'More workers increase load and heat',
  'threads.gpuTitle': 'GPU pipelines',
  'threads.gpuDescription': '{count} parallel WebGPU pipelines',
  'threads.auto': 'Auto · {count}',
  'threads.maximum': 'Maximum · {count}',
  'threads.manual': '{count}',
  'compute.title': 'Acceleration',
  'compute.description': 'Choose a compute engine',
  'compute.cpu': 'CPU',
  'compute.cpuDescription': 'Stable mode · multiple workers',
  'compute.gpu': 'GPU · Beta',
  'compute.gpuDescription': 'Parallel WebGPU pipelines · maximum throughput',
  'compute.gpuUnavailable': 'WebGPU is unavailable in this browser',
  'compute.gpuPreparing': 'Checking your graphics card…',
  'compute.mobileTitle': 'Phone-friendly mode',
  'compute.mobileDescription': 'GPU is hidden and the default is {count} CPU workers to limit heat',
  'format.title': 'Address format',
  'format.nonBounceable': 'Non-bounceable · convenient for receiving',
  'format.bounceable': 'Bounceable · standard format',
  'consent.title': 'I understand how to save the wallet',
  'consent.description': 'If you close this tab before saving the recovery phrase, the found wallet cannot be recovered.',
  'action.start': 'Start hunting',
  'privacy.localCompute': 'Everything is computed on this device',
  'search.title': 'Utya is already hunting',
  'search.description': 'Searching for …{suffix} in {version} addresses · {engine}. You may leave this tab open.',
  'search.running': 'Search in progress',
  'search.attempts': 'attempts checked',
  'search.speed': 'Speed',
  'search.time': 'Time',
  'search.estimate': 'Estimate',
  'search.sample': 'Latest candidate',
  'search.preparing': 'Preparing the generator…',
  'search.random': 'The search is random. It may finish sooner or later than the estimate.',
  'search.stop': 'Stop',
  'search.paused': 'Hunt paused',
  'search.pause': 'Pause',
  'search.resume': 'Resume',
  'search.power': 'Power',
  'power.title': 'Search power',
  'power.description': 'Change the engine or worker count. Attempts and active time are preserved.',
  'power.close': 'Close power settings',
  'power.current': 'Will run: {count}',
  'power.apply': 'Apply power',
  'engine.cpu': 'CPU · {count}',
  'engine.gpu': 'GPU · WebGPU',
  'engine.gpuParallel': 'GPU · {count} pipelines',
  'eta.measuring': 'Measuring…',
  'eta.minutes': '≈ {count} min',
  'eta.hours': '≈ {count} hr',
  'eta.days': '≈ {count} days',
  'eta.years': '≈ {count} years',
  'found.status': 'Found',
  'found.title': 'Now that is an address!',
  'found.description': 'Utya found the requested ending. Check the address before saving the wallet.',
  'found.copyAddress': 'Copy address',
  'found.copiedAddress': 'Address copied',
  'found.attempts': 'Attempts',
  'found.time': 'Time',
  'found.hiddenTitle': 'Recovery words are still hidden',
  'found.hiddenDescription': 'They exist only in this tab’s memory and disappear when it is closed.',
  'found.reveal': 'Use this address',
  'found.revealPending': 'Preparing recovery words…',
  'found.retry': 'Search for another address',
  'seedReady.status': 'Recovery words are not revealed',
  'seedReady.title': 'Ready to save the key?',
  'seedReady.description': 'The {count} words appear only after you confirm. Until then, they stay inside the generator.',
  'seedReady.check': 'I am in a private place',
  'seedReady.checkDescription': 'Nobody can see the screen, and screen recording or sharing is off.',
  'seedReady.reveal': 'Show the {count} words',
  'seedReady.back': 'Back to the address',
  'seed.status': 'Only for you',
  'seed.title': 'Save these {count} words',
  'seed.description': 'This is the only key to the wallet. Write the words down in order and store them offline.',
  'seed.warningTitle': 'Never share your recovery words',
  'seed.warningDescription': 'TonSuite will never ask for them in a chat, bot, or support message.',
  'seed.phrase': 'Recovery phrase',
  'seed.hide': 'Hide',
  'seed.show': 'Show',
  'seed.hidden': 'The {count} words are hidden',
  'seed.copied': 'Copied',
  'seed.copy': 'Copy {count} words',
  'seed.restart': 'I saved them — start again',
  'seed.notStored': 'The phrase is not stored in your browser',
  'footer.privacy': 'Privacy',
  'footer.utya': 'Utya',
  'footer.author': 'Author · @rub1kub',
  'footer.channel': 'Developer channel',
  'huntModal.close': 'Close dialog',
  'huntModal.status': 'The hunt has started',
  'huntModal.title': 'Free, local, and all good',
  'huntModal.description': 'The generator is already searching on your device. Follow the developer channel for TonSuite updates, new tools, and the fun bits.',
  'huntModal.notification': 'When the wallet is found, you will hear a chime and get a system notification if the browser allows it.',
  'huntModal.subscribe': 'Follow the channel',
  'huntModal.continue': 'Continue the hunt',
  'notification.title': 'TonSuite: wallet found!',
  'notification.body': 'Utya found a TON address with your ending. Return to this tab to check it.',
  'error.generator': 'The local generator could not start. Refresh the page or update your browser.',
  'error.walletMissing': 'The found wallet is no longer available. Start a new search.',
  'error.clipboard': 'The browser denied clipboard access. Copy the value manually.',
  'error.gpuFallback': 'GPU self-test failed. The search continued on CPU.',
};

const messages: Record<Locale, Record<MessageKey, string>> = { ru, en };

export function detectLocale(pathname = window.location.pathname): Locale {
  return /^\/en(?:\/|$)/.test(pathname) ? 'en' : 'ru';
}

export function translate(
  locale: Locale,
  key: MessageKey,
  values: Record<string, string | number> = {},
): string {
  let message = messages[locale][key];
  for (const [name, value] of Object.entries(values)) {
    message = message.replaceAll(`{${name}}`, String(value));
  }
  return message;
}

export function generatorHref(locale: Locale): string {
  return locale === 'en' ? '/en/generator/' : '/generator/';
}

export function homeHref(locale: Locale): string {
  return locale === 'en' ? '/en/' : '/';
}

export function alternateLocale(locale: Locale): Locale {
  return locale === 'en' ? 'ru' : 'en';
}
